export default __webpack_public_path__ + "72810d071e272f0158f0672be5464d02.png";